import React from 'react';
import PropTypes from 'prop-types'

import css from './StandardButton.module.scss'

const StandardButton = ({text, type, clickHandler, disabled}) => {
  const typeCss = (type === "default") ? null : css.link
  const disabledCss = disabled ? css.disabled : null
  return (
    <button className={`${css.buttonCss} ${typeCss} ${disabledCss}`} onClick={clickHandler} disabled={disabled}>{text}</button>
  )
}

StandardButton.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["default", "link"]),
  clickHandler: PropTypes.func,
  disabled: PropTypes.bool
}

StandardButton.defaultProps = {
  type: "default",
  clickHandler: Function.prototype,
  disabled: false
}

export default StandardButton;
